var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SfButton',{staticClass:"a-add-to-cart sf-button--full-width",attrs:{"disabled":_vm.isProductDisabled},nativeOn:{"click":function($event){return _vm.addToCart.apply(null, arguments)}}},[_vm._v("\n  "+_vm._s(_vm.label)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }